import { getSignalEventPeriod } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getSignalEventDate";
import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { TechnologySignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import TechnologyChangesType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesType";

import NameStringWithTooltip from "./NameStringWithTooltip";
import { StyledSignalText } from "./styles";

type TechnologySignalEventInfoProps = {
    signal: TechnologySignalEventDto;
    companyName: string;
};

const TechnologySignalEventInfo = ({ signal, companyName }: TechnologySignalEventInfoProps) => {
    const { technologies, periodDays, changeType } = signal;

    if (technologies.length === 1) {
        return changeType === TechnologyChangesType.Removed && !!periodDays ? (
            <StyledSignalText>{`${technologies[0]} was installed for ${getSignalEventPeriod(
                periodDays,
            )}`}</StyledSignalText>
        ) : null;
    }

    return changeType !== TechnologyChangesType.RenewalComingUp ? (
        <NameStringWithTooltip
            names={technologies}
            text={signalEventsService.getTechnologySignalEventText(signal, companyName)}
        />
    ) : null;
};

export default TechnologySignalEventInfo;
